
import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card } from '@themesberg/react-bootstrap';
import packageJson from '../../package.json';

const Footer = () => {
  const currentYear = moment().get("year");

  return (
    <div>
      <footer className="footer section py-5">
        <Row>
          <Col xs={12} className="mb-4 mb-lg-0">
            <p className="mb-0 text-center">
              Copyright © {`${currentYear} `}
              <span className="fw-bold">Inovare Gestão</span>
              {' '}- Sistema de Gestão Escolar
              <span className="text-muted ms-2" style={{ fontSize: '0.85rem' }}>
                v{packageJson.version}
              </span>
            </p>
            <p className="mb-0 text-center mt-2">
              Desenvolvido por{' '}
              <Card.Link 
                href="https://www.linkedin.com/in/jose-gui/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue text-decoration-none fw-normal"
              >
                José Guilherme
              </Card.Link>
            </p>
          </Col>
        </Row>
      </footer>
    </div>
  );
};

export default Footer;
